import React from "react";

interface Props {
    /** 1: Normal, 2: Aylık Sabit Gelir */
    secili: 1 | 2
    onChange: (_tur: 1 | 2) => void
}

// Mat turuncu (09.10.2026, Burak): ekrandaki mavi gezinme çubuğuyla karışmasın, göze batsın ama çiğ olmasın.
const RENK = {
    vurgu: '#DD8A4E',
    yazi: '#A75A24',
    cerceve: '#EDB48A',
    zemin: '#FFF6EE',
}

/** Sipariş Ekle'de sipariş türü seçimi: Normal ya da Aylık Sabit Gelir. */
const SiparisTuruSecici = ({ secili, onChange }: Props) => {
    const dugme = (tur: 1 | 2, metin: string) => (
        <button
            type="button"
            className="btn btn-sm fw-bold"
            onClick={secili == tur ? undefined : () => onChange(tur)}
            style={{
                borderRadius: 0,
                padding: "3px 12px",
                fontSize: 12,
                lineHeight: 1.5,
                background: secili == tur ? RENK.vurgu : '#FFFFFF',
                color: secili == tur ? '#FFFFFF' : RENK.yazi,
                cursor: secili == tur ? 'default' : 'pointer',
            }}
        >
            {metin}
        </button>
    )

    return (
        <div className="d-inline-flex align-items-center gap-2 px-3 py-1 rounded" style={{ border: '1px solid ' + RENK.cerceve, background: RENK.zemin }}>
            <span className="fw-bold fs-7" style={{ color: RENK.yazi }}>Sipariş türü:</span>

            <div className="d-flex rounded overflow-hidden" style={{ border: '1px solid ' + RENK.vurgu }}>
                {dugme(1, 'Normal')}
                <span style={{ width: 1, background: RENK.vurgu }} />
                {dugme(2, 'Aylık Sabit Gelir')}
            </div>
        </div>
    )
}

export default SiparisTuruSecici;
